export default __webpack_public_path__ + "static/media/968.0f401804.gif";